import React from 'react';
import buttonStyles from '../../styles/buttons.module.css';
import styles from './AccountEquipmentList.module.css';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Card, CardContent, CardMedia, Pagination, PaginationItem, Skeleton } from '@mui/material';
import Typography from '@mui/material/Typography';

function AccountEquipmentList(props) {
  const [maxCards, setMaxCards] = React.useState(15);

  React.useEffect(() => {
    const updateMaxCards = () => {
      if (props.screenWidth < 600) {
        setMaxCards(5);
      } else if (props.screenWidth < 900) {
        setMaxCards(8);
      } else {
        setMaxCards(15);
      }
    };
  
    updateMaxCards();
  }, [props.screenWidth]);

  function displayLoadingGraphics() {
    let loadingGraphic = [];
    for (let index = 1; index <= 5; index++) {
      loadingGraphic.push(<Skeleton variant='rectangular' width={180} height={235} sx={{ margin: '0px 10px 10px 10px' }} />)
    }

    return loadingGraphic;
  }
  
  return (
    <>
    <h2 className={styles.title}>My Equipment</h2>
    <div className={styles.account_equipment_list} style={{ width: '100%', height: 'auto', border: '1px solid #ddd', fontSize: 12 }}>
      <div className={styles.container}>
        <BrandFilter
          selectedBrand={props.filterValues.brand}
          brands={props.accountEquipmentBrands}
          handleChange={props.handleChange}
        />
        <SubTypeFilter
          selectedSubType={props.filterValues.subtype}
          subtypes={props.accountEquipmentSubTypes}
          handleChange={props.handleChange}
        />
        <FilterButton submit={props.handleSubmit} />
        <ClearButton clearFilter={props.handleFilterClear} />
      </div>
      <div className={styles.equipment_card_container}>
          {props.loading ? 
            displayLoadingGraphics()
          :
          props.accountEquipment.data?.slice(0, maxCards).map((equipment) => (
            <EquipmentCard key={equipment.equipment_id} equipment={equipment} />
          ))}
        <div className={styles.pagination_container}>
          {(props.accountEquipment.last_page && props.accountEquipment.total > 15) ? (
            <Paginator
              screenWidth={props.screenWidth}
              accountEquipment={props.accountEquipment} 
              getNextPage={props.handlePagination} 
              filterValues={props.filterValues} 
              maxCards={maxCards}
            />
          ) : null}
        </div>
      </div>
    </div>
    </>
  );
}

export default AccountEquipmentList;

function SubTypeFilter(props) {
  const isPlaceholder = props.selectedSubType === "";

  return (
    <select
      className={styles.filter_input}
      style={{
        color: isPlaceholder ? "#999" : "#000",
        fontStyle: isPlaceholder ? "italic" : "normal",
      }}
      value={props.selectedSubType}
      onChange={(e) => props.handleChange(e, "subtype")}
    >
      <option value="" hidden>
        All Types
      </option>
      <option value="" className={styles.default_value}>
        All Types
      </option>
      {props.subtypes.map((type) => (
        <option key={type?.equipment_sub_type_id} value={type?.equipment_sub_type_id} className={styles.default_value}>
          {type?.equipment_sub_type_name}
        </option>
      ))}
    </select>
  );
}

function BrandFilter(props) {
  const isPlaceholder = props.selectedBrand === "";

  return (
    <select
      className={styles.filter_input}
      style={{
        color: isPlaceholder ? "#999" : "#000",
        fontStyle: isPlaceholder ? "italic" : "normal",
      }}
      value={props.selectedBrand}
      onChange={(e) => props.handleChange(e, "brand")}
    >
      <option value="" hidden>
        All Brands
      </option>
      <option value="" className={styles.default_value}>
        All Brands
      </option>
      {props.brands.map((brand) => (
        <option key={brand.brand_id} value={brand.brand_id} className={styles.default_value}>
          {brand.brand_name}
        </option>
      ))}
    </select>
  );
}

function EquipmentCard(props) {
  return (
    <Card
      variant='outlined'
      key={props.equipment.equipment_id}
      className={styles.equipment_card}
    >
      <a href={props.equipment.link}>
        <CardMedia
          component='img'
          height={140}
          image={props.equipment.equipment_images.small}
          alt={props.equipment.brand.brand_name + ' ' + props.equipment.equipment_name + ' primary image'}
          sx={{ objectFit: 'contain' }}
        />
      </a>
      <CardContent sx={{ textAlign: 'center' }}>
        <Typography
          variant="h5"
          component="div"
          sx={{ textAlign: 'center', padding: 0 }}
        >
          <a href={props.equipment.link} style={{ color: 'black' }}>
            {props.equipment.brand.brand_name} - {props.equipment.equipment_name}
          </a>
        </Typography>
      </CardContent>
    </Card>
  );
}

function FilterButton(props) {
  return (
    <button
      className={buttonStyles.submitButton}
      style={{ margin: '28px 0px 0px 5px', height: 25, width: 70 }}
      onClick={props.submit}
    >
      Filter <FilterAltIcon sx={{ fontSize: 12 }} />
    </button>
  )
}

function ClearButton(props) {
  return (
    <button
      className={buttonStyles.cancelButton}
      style={{ margin: '28px 0px 0px 10px', height: 25, width: 70 }}
      onClick={props.clearFilter}
    >
      Clear <FilterAltOffIcon sx={{ fontSize: 12 }} />
    </button>
  )
}

function Paginator(props) {
  const getSiblingCount = () => {
    if (props.screenWidth > 1200) return 2;
    if (props.screenWidth > 800) return 1;
    return 0;
  };

  return (
    <div className={styles.pagination}>
      <Pagination
        count={props.accountEquipment.last_page}
        page={props.accountEquipment.current_page}
        onChange={(e, page) => props.getNextPage(page, props.maxCards)}
        color="primary"
        variant="outlined"
        siblingCount={getSiblingCount()}
        boundaryCount={0}
        renderItem={(item) => <PaginationItem {...item} />}
      />
    </div>
  );
}